
<DataPage
  ref="entitiesTable"
  :columns="columns"
  :filters="filters"
  :title="__('entities.list')"
  :pre-title="__('entities.pre-title')"
  :fetch-callback="fetchEntities"
  :model="EntityModel"
  has-row-actions
>
  <template #pageActions>
    <b-button
      v-can:entities.create
      variant="primary"
      size="sm"
      data-testid="create-entity-btn"
      @click="handleCreateEntity"
    >
      <Icon icon="plus-circle" size="14" class="mr-2" />
      {{ __('entities.create') }}
    </b-button>
  </template>

  <template #name="{ item }">
    <RouterLink
      :to="{ name: 'entities.show', params: { entityId: item.id } }"
    >
      {{ item.name }}
    </RouterLink>
  </template>

  <template #parent="{ item }">
    <Badge :variant="item.isGroup ? 'soft-success' : 'soft-danger'">
      {{ item.isGroup ? __('common.yes') : __('common.no') }}
    </Badge>
  </template>

  <template #type="{ item }">
    <Badge :variant="item.typeData().badge">
      {{ item.typeData().short }}
    </Badge>
  </template>

  <template #status="{ item }">
    <Badge :variant="item.statusData().badge">
      {{ __(item.statusData().label) }}
    </Badge>
  </template>

  <template #usersCount="{ item }">
    {{
      item.isChild
        ? item.usersCount + item.subsidiaryEntityUsersCount
        : item.usersCount
    }}
  </template>

  <template #actionButtons="{ item }">
    <ActionPopover
      :id="item.id"
      v-can-any="['entities.update', 'entities.destroy']"
    >
      <b-button
        v-can:entities.update
        class="dropdown-item"
        size="sm"
        @click="handleEdit(item.id)"
      >
        <Icon icon="edit" class="mr-2" size="14" />
        {{ __('buttons.edit') }}
      </b-button>

      <b-button
        v-can:entities.destroy
        class="dropdown-item"
        size="sm"
        @click="remove(item.id)"
      >
        <Icon icon="trash" class="mr-2" size="14" />
        {{ __('buttons.remove') }}
      </b-button>
    </ActionPopover>
  </template>
</DataPage>
